import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type LawyerCustomerInteractionsQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']
}>

export type LawyerCustomerInteractionsQuery = {
  __typename?: 'Query'
  lawyerCustomerInteractions: Array<{
    __typename?: 'LawyerCustomerInteraction'
    id: number
    updatedAt: any
    latestAppointmentDate?: any | null
    topicName: string
    customer: {
      __typename?: 'CustomerForInteraction'
      id: number
      firstName: string
      lastName: string
    }
  }>
}

export const LawyerCustomerInteractionsDocument = gql`
  query LawyerCustomerInteractions($limit: Int!) {
    lawyerCustomerInteractions(limit: $limit) {
      id
      updatedAt
      customer {
        id
        firstName
        lastName
      }
      latestAppointmentDate
      topicName
    }
  }
`
export function useLawyerCustomerInteractionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    LawyerCustomerInteractionsQuery,
    LawyerCustomerInteractionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LawyerCustomerInteractionsQuery,
    LawyerCustomerInteractionsQueryVariables
  >(LawyerCustomerInteractionsDocument, options)
}
export function useLawyerCustomerInteractionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LawyerCustomerInteractionsQuery,
    LawyerCustomerInteractionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LawyerCustomerInteractionsQuery,
    LawyerCustomerInteractionsQueryVariables
  >(LawyerCustomerInteractionsDocument, options)
}
export type LawyerCustomerInteractionsQueryHookResult = ReturnType<
  typeof useLawyerCustomerInteractionsQuery
>
export type LawyerCustomerInteractionsLazyQueryHookResult = ReturnType<
  typeof useLawyerCustomerInteractionsLazyQuery
>
export type LawyerCustomerInteractionsQueryResult = ApolloReactCommon.QueryResult<
  LawyerCustomerInteractionsQuery,
  LawyerCustomerInteractionsQueryVariables
>
export function refetchLawyerCustomerInteractionsQuery(
  variables?: LawyerCustomerInteractionsQueryVariables
) {
  return { query: LawyerCustomerInteractionsDocument, variables: variables }
}
